const AUTH_STORAGE_KEY = 'vidya_kasam_auth';

function canUseStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

function readAuthState() {
  if (!canUseStorage()) {
    return null;
  }

  try {
    const rawValue = window.localStorage.getItem(AUTH_STORAGE_KEY);
    if (!rawValue) {
      return null;
    }

    const parsedValue = JSON.parse(rawValue);
    if (!parsedValue || typeof parsedValue !== 'object') {
      return null;
    }

    return parsedValue;
  } catch (error) {
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
    return null;
  }
}

export function getStoredAuth() {
  return readAuthState();
}

export function getAccessToken() {
  return readAuthState()?.accessToken || '';
}

export function getStoredUser() {
  return readAuthState()?.user || null;
}

export function persistAuthSession(session) {
  if (!canUseStorage()) {
    return;
  }

  const normalizedSession = {
    accessToken: session?.accessToken || '',
    user: session?.user || null,
    expiresIn: session?.expiresIn || null,
    tokenType: session?.tokenType || 'bearer',
    storedAt: Date.now(),
  };

  window.localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(normalizedSession));
}

export function clearAuthSession() {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.removeItem(AUTH_STORAGE_KEY);
}

export function isAuthenticated() {
  return Boolean(getAccessToken());
}

export { AUTH_STORAGE_KEY };
